import React from "react";

const LinkIcon = ({ className = "", restProps }) => {
  return (
    <svg
      width="17"
      height="21"
      viewBox="0 0 17 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...restProps}
    >
      <path
        d="M7.80607 4.14507L10.0299 1.92129C11.4361 0.678582 13.529 0.809393 14.7717 2.18291C15.9163 3.42561 15.9163 5.35507 14.7717 6.63048L12.5153 8.85427L13.202 9.54103L15.4585 7.28454C17.1263 5.6167 17.0609 2.86967 15.3604 1.20183C13.6926 -0.400609 11.0436 -0.400609 9.3758 1.20183L7.11931 3.42561C5.45147 5.12615 5.45147 7.84048 7.11931 9.54102L7.80607 8.85427C6.53066 7.54616 6.53066 5.45318 7.80607 4.14507Z"
        fill="white"
      />
      <path
        d="M7.41353 19.0575L9.67002 16.8337C11.3379 15.1332 11.3379 12.4189 9.67002 10.751L8.98326 11.4378C10.2914 12.7459 10.2914 14.8389 8.98326 16.147L6.72677 18.3708C5.41866 19.6789 3.32569 19.6789 2.01758 18.3708C0.709468 17.0627 0.709468 14.9697 2.01758 13.6616L4.27407 11.4378L3.58731 10.751L1.36352 12.9748C-0.369723 14.6099 -0.467831 17.3243 1.16731 19.0575C2.80244 20.7908 5.51677 20.8889 7.25002 19.2537C7.31542 19.1556 7.38083 19.1229 7.41353 19.0575Z"
        fill="white"
      />
      <path
        d="M11.4833 7.79548L10.7896 7.10176L5.37851 12.5128L6.07223 13.2065L11.4833 7.79548Z"
        fill="white"
      />
    </svg>
  );
};

export default LinkIcon;
